import { apiPost, apiPut } from 'api';
import { UpsertParentOrganisationRequest, UpsertParentOrganisationResponse } from '..';

export const upsertParentOrganisation = (
  request: UpsertParentOrganisationRequest
): Promise<UpsertParentOrganisationResponse> =>
  request.parentOrganisationId
    ? apiPut<UpsertParentOrganisationResponse, UpsertParentOrganisationRequest>(
        `admin/parentorganisations/${request.parentOrganisationId}`,
        request
      )
    : apiPost<UpsertParentOrganisationResponse, UpsertParentOrganisationRequest>(
        'admin/parentorganisations',
        request
      );
